import React from 'react';
import { useSelector } from 'react-redux';

import FacetFilter from './FacetFilter';

const ClientFilters = ({ values, onChange, text }) => {
  const { clientFacetData } = useSelector(({ search }) => search);

  switch (text) {
    case 'Подразделения':
      return (
        <FacetFilter
          text="Подразделения"
          options={clientFacetData?.cashboxes}
          values={values}
          onChange={onChange}
        />
      );
    case 'Филиалы':
      return (
          <FacetFilter
              text="Филиалы"
              options={clientFacetData?.branches}
              values={values}
              onChange={onChange}
          />
      );


    default:
      return null;
  }
};

export default ClientFilters;
